/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.post'

type $nsid = typeof $nsid

export { $nsid }

/** A fork-owned post stored in a permissioned account or community space. It is never a public app.bsky.feed.post record. */
type Main = {
  $type: 'us.edriffles.radlib.private.post'
  text: string
  facets?: l.LexMap[]
  createdAt: l.DatetimeString
  langs?: string[]
  reply?: l.LexMap
  embed?: l.LexMap
  community?: string
}

export type { Main }

/** A fork-owned post stored in a permissioned account or community space. It is never a public app.bsky.feed.post record. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    text: /*#__PURE__*/ l.string({ maxLength: 3000 }),
    facets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap(), { maxLength: 256 }),
    ),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    langs: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), { maxLength: 3 }),
    ),
    reply: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    embed: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),
    community: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { main }

const $type = $nsid

type $type = typeof $type

export { $type }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main)
export const $build = /*#__PURE__*/ main.build.bind(main)
export const $assert = /*#__PURE__*/ main.assert.bind(main)
export const $check = /*#__PURE__*/ main.check.bind(main)
export const $cast = /*#__PURE__*/ main.cast.bind(main)
export const $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main)
export const $matches = /*#__PURE__*/ main.matches.bind(main)
export const $parse = /*#__PURE__*/ main.parse.bind(main)
export const $safeParse = /*#__PURE__*/ main.safeParse.bind(main)
export const $validate = /*#__PURE__*/ main.validate.bind(main)
export const $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)
